export { default, createRoot, hydrateRoot, version } from 'react-dom/client';
